export default __webpack_public_path__ + "img/detail.a5a1e984.webp";